import { TitleProps } from 'antd/lib/typography/Title';
import { Title as TitleComponent } from 'components';
import { theme } from 'configs/styled';
import React from 'react';

export interface ITitleProps extends TitleProps {
  color?: string;
  fontSize?: string;
  style?: React.CSSProperties;
}

const Title: React.FC<ITitleProps> = ({
  color = theme.palettes.black85,
  fontSize = theme.fontSize.xl,
  style,
  ...props
}) => {
  return (
    <TitleComponent
      {...props}
      style={{
        color,
        fontWeight: theme.fontWeight.medium,
        fontStyle: 'normal',
        fontSize,
        lineHeight: '28px',
        ...style,
      }}
    />
  );
};

export default Title;
